<template>
    <v-snackbar  v-model="$store.state.APP.SNACKBAR.SHOW">
        {{this.$store.state.APP.SNACKBAR.MESSAGE}}
        <v-btn text @click.native="$store.state.APP.SNACKBAR.SHOW= false">Stäng</v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        name: "Snackbar"
    }
</script>

<style scoped>

</style>
